export { default } from "./useSchoolsByRole";
